import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  documents_type: [],
  banks: [],
  electronic_points: [],
  document_last_mount: 0,
  user: [],
  ruap_received: [],
  other_ruaps: [],
  devolutions_list: [],
  documents_requirements: {},
  documents_type_childs: []
}

// mutations
export const mutations = {

  [types.SET_DOCUMENT_TYPE] (state, { payload }) {
    state.documents_type = []
    state.documents_type_childs = []
    state.banks = payload.banks
    state.devolutions_list = payload.devolutions
    state.electronic_points = payload.electronic_points
    state.document_last_mount = 0
    state.user = []
    state.created_ruap = false
  },

  [types.SET_DOCUMENT_INFO] (state, { payload }) {
    state.documents_type = payload.documents_type
    state.documents_type_childs = payload.documents_type_childs
  },

  [types.SET_DOCUMENT_LAST_MOUNT] (state, { payload }) {
    state.document_last_mount = payload === '' || Object.entries(payload).length === 0 ? 0 : payload.amount
  },

  [types.SET_STATUS_USER] (state, { payload }) {
    state.user = payload
  },

  [types.SET_RUAP_RECEIVED] (state, { payload }) {
    state.ruap_received = payload
  },

  [types.SET_RUAP_UPDATE_RECEIVED] (state, { payload }) {
    state.ruap_received = payload
  },

  [types.SET_DOCUMENT_REQUIREMENT] (state, { payload }) {
    state.documents_requirements = payload
  },

  [types.SET_DOCUMENT_CHILD] (state, { payload }) {
    state.documents_type_childs = payload
  },

  [types.SET_OTHER_RAP_NO_PAY] (state, { payload }) {
    state.other_ruaps = payload
  }

}

// actions
export const actions = {

  async fetchSatDocumentsType ({ commit }) {
    try {
      const { data } = await axios.get(`/api/sat/getAllSatDocumentType`)
      commit(types.SET_DOCUMENT_TYPE, { payload: data })
    } catch (e) {
      // commit(types.SET_DOCUMENT_TYPE, { payload: [] })
    }
  },

  async submitNewRuap ({ commit, dispatch }, payload) {
    try {
      const { data } = await axios.post(`/api/sat/store`, payload)
      dispatch('responseMessage', {
        type: 'success',
        text: 'Nueva actuacion profesional creada!'
      })
      commit(types.SET_RUAP_RECEIVED, { payload: data })
    } catch (e) {
      console.log(e.response, 'reserror')
      if (e.response.data.errors) {
        for (var indice in e.response.data.errors) {
          dispatch('responseMessage', {
            type: 'error',
            text: e.response.data.errors[indice]
          })
        }
      }
    }
  },

  async submitUpdateRuap ({ commit, dispatch }, payload) {
    try {
      const { data } = await axios.post(`/api/sat/update`, payload)
      commit(types.SET_RUAP_RECEIVED, { payload: data })
    } catch (e) {
      console.log(e.response)
      if (e.response.data.errors) {
        for (var indice in e.response.data.errors) {
          dispatch('responseMessage', {
            type: 'error',
            text: e.response.data.errors[indice]
          })
        }
      }
    }
  },

  async deleteRap ({ commit, dispatch }, payload) {
    try {
      const { data } = await axios.delete(`/api/sat/delete/${payload.id}/${payload.status}`)
      commit(types.SET_RUAP_RECEIVED, { payload: data })
    } catch (e) {
      console.log(e.response)
      if (e.response.data.errors) {
        for (var indice in e.response.data.errors) {
          dispatch('responseMessage', {
            type: 'error',
            text: e.response.data.errors[indice]
          })
        }
      }
    }
  },

  async submitConciliacionRuap ({ commit, dispatch }, payload) {
    try {
      const { data } = await axios.post(`/api/sat/conciliacion`, payload)
      commit(types.SET_RUAP_RECEIVED, { payload: data })
    } catch (e) {
      console.log(e.response)
    }
  },

  async submitRevisionRuap ({ commit }, payload) {
    try {
      const { data } = await axios.post(`/api/sat/revision`, payload)
      commit(types.SET_RUAP_RECEIVED, { payload: data })
    } catch (e) {
      console.log(e.response)
    }
  },

  async submitRevisionRuapClient ({ commit }, payload) {
    try {
      const { data } = await axios.post(`/api/cliente/ap-revision`, payload)
      commit(types.SET_RUAP_RECEIVED, { payload: data })
    } catch (e) {
      console.log(e.response)
    }
  },

  async searchDocumentRuapRequirement ({ commit, dispatch }, payload) {
    try {
      const { data } = await axios.get(`/api/sat/search-ruap-document-selected/${payload}`)
      commit(types.SET_DOCUMENT_REQUIREMENT, { payload: data })
    } catch (e) {
      console.log(e.response)
    }
  },

  async validCpcRuap ({ commit }, payload) {
    try {
      if (payload !== '') {
        const { data } = await axios.get(`/api/searchcpc/${payload}`)
        commit(types.SET_STATUS_USER, { payload: data })
      } else {
        commit(types.SET_STATUS_USER, { payload: [] })
      }
    } catch (e) {
      // commit(types.ADD_CPC_FORM_FAILURE)
    }
  },

  async fetchPriceDocument ({ commit }, payload) {
    try {
      if (payload !== '') {
        const { data } = await axios.post(`/api/sat/search-amount-document`, payload)
        commit(types.SET_DOCUMENT_LAST_MOUNT, { payload: data })
      } else {
        commit(types.SET_DOCUMENT_LAST_MOUNT, { payload: payload })
      }
    } catch (e) {
      console.log(e.response)
      // commit(types.ADD_CPC_FORM_FAILURE)
    }
  },

  async fetchChildDocument ({ commit }, payload) {
    try {
      if (payload !== '') {
        const { data } = await axios.post(`/api/sat/search-child-document`, { document_type_child: payload })
        commit(types.SET_DOCUMENT_CHILD, { payload: data })
      } else {
        commit(types.SET_DOCUMENT_CHILD, { payload: payload })
      }
    } catch (e) {
      console.log(e.response)
      // commit(types.ADD_CPC_FORM_FAILURE)
    }
  },

  async fetchInfoDocumentType ({ commit }, payload) {
    try {
      const { data } = await axios.post(`/api/sat/search-info-document-type`, { personalidad: payload })
      commit(types.SET_DOCUMENT_INFO, { payload: data })
    } catch (e) {
      console.log(e.response)
      // commit(types.ADD_CPC_FORM_FAILURE)
    }
  },

  async fetchSatSearchOtherRap ({ commit }, payload) {
    try {
      const { data } = await axios.post(`/api/sat/search-other-rap`, { data: payload })
      commit(types.SET_OTHER_RAP_NO_PAY, { payload: data })
    } catch (e) {
      console.log(e.response)
      // commit(types.ADD_CPC_FORM_FAILURE)
    }
  },

  searchRaupConceptData ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post(`/api/sat/search-ruap-concept`, { ruap_id: payload }).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  }

}

// getters
export const getters = {
  getSatDocumentsType: state => state.documents_type,
  getSatDocumentsTypeChild: state => state.documents_type_childs,
  getSatBanks: state => state.banks,
  getSatDevolutionsList: state => state.devolutions_list,
  getSatStatusUser: state => state.user,
  getSatRuapReceived: state => state.ruap_received,
  getSatOtherRuap: state => state.other_ruaps,
  getSatDocumentPrice: state => state.document_last_mount,
  getSatElectronicPoints: state => state.electronic_points,
  getDocumentRequirementSat: state => state.documents_requirements
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/ruap.js